import { render } from "./RemoteControllerSetting.vue?vue&type=template&id=428521f7&scoped=true"
import script from "./RemoteControllerSetting.vue?vue&type=script&lang=js"
export * from "./RemoteControllerSetting.vue?vue&type=script&lang=js"

import "./RemoteControllerSetting.vue?vue&type=style&index=0&id=428521f7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428521f7"]])

export default __exports__